import type {Translations, TranslationParams, ValidTranslationKey} from '../types/translations';

export function translateWithTranslations(
    translations: Translations,
    transKey: ValidTranslationKey,
    params: TranslationParams = []
): string {
    if (!translations || !translations[transKey]) {
        return transKey;
    }

    let trans = translations[transKey]!;

    for (const [key, value] of Object.entries(params)) {
        trans = trans.replace(key, value?.toString() ?? '');
    }

    return trans;
}
